import { render, staticRenderFns } from "./ProductReviewVotes.vue?vue&type=template&id=7b1d0bc2&scoped=true&"
import script from "./ProductReviewVotes.vue?vue&type=script&lang=js&"
export * from "./ProductReviewVotes.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewVotes.vue?vue&type=style&index=0&id=7b1d0bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d0bc2",
  null
  
)

export default component.exports